export default (updateSearch) => {
  Array.from(document.querySelectorAll('.product-search__filter-select')).forEach((input) => {
    const selectedValue = () => {
      const options = input.children;
      if (options && options.length >= (input.selectedIndex + 1)) 
      {
        const selected = options[input.selectedIndex];
        return selected && selected.value && selected.value !== 'Any' ? selected.value : false;
      }
      return false;
    };

    input.addEventListener('change', () => {
      updateSearch({ [input.name]: selectedValue() });
    });
    if (selectedValue()) {
      updateSearch({ [input.name]: selectedValue() });
    }
  });
};
